<template>
  <div>
    <button
      class="flex items-center justify-between rounded-full bg-background p-1"
      type="button"
      @click="showDrawer"
    >
      <span class="mx-2 line-clamp-1 text-xs">
        {{ label }}
      </span>
      <IconChevronDown
        class="rounded-full bg-background-fg/10"
      />
    </button>

    <BaseDrawer
      shrink
      :is-open="isDrawerOpen"
      @close="hideDrawer"
    >
      <div
        v-if="step === 'select'"
        class="flex flex-col pb-4 pt-2"
      >
        <button
          v-for="option in transactionReportNamedPeriods"
          :key="option"
          :class="[
            option === modelValue
              ? 'bg-background-fg/5'
              : 'text-background-fg/50 hover:bg-background-fg/3',
            'cursor-pointer px-3 py-2 text-center font-semibold',
          ]"
          @click="handleSelectDefinedOption(option)"
        >
          {{ option }}
        </button>
        <button
          :class="[
            'text-background-fg/50 hover:bg-background-fg/3',
            'cursor-pointer px-3 pt-2 text-center text-sm font-semibold',
          ]"
          @click="handleSelectCustom"
        >
          Custom
        </button>
      </div>
      <template v-else-if="step === 'custom'">
        <BaseDatePicker
          :model-value="datePickerValue"
          disable-future
          @update:model-value="handlePickDate"
        />
      </template>
    </BaseDrawer>
  </div>
</template>

<script setup lang="ts">
import { transactionReportNamedPeriods } from "@/services/reports/retrieveTransactionReport"
import type { TransactionReportPeriod } from "@/services/reports/retrieveTransactionReport"

const props = defineProps<{
  modelValue: TransactionReportPeriod
}>()

const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: TransactionReportPeriod
  ): void
}>()

const label = computed(() => {
  return typeof props.modelValue === "string"
    ? props.modelValue
    : props.modelValue.date
      ? formatToDate(props.modelValue.date)
      : ""
})

const datePickerValue = computed(() =>
  typeof props.modelValue === "object" &&
  props.modelValue.date
    ? DateFns.format(props.modelValue.date, "yyyy-MM-dd")
    : null
)

const isDrawerOpen = ref(false)
const showDrawer = () => {
  step.value = "select"
  isDrawerOpen.value = true
}
const hideDrawer = () => {
  isDrawerOpen.value = false
}

const step = ref("select")
const handleSelectCustom = () => {
  step.value = "custom"
}

const handleSelectDefinedOption = (
  value: (typeof transactionReportNamedPeriods)[number]
) => {
  emit("update:modelValue", value)
  hideDrawer()
}

const handlePickDate = (date: string | null) => {
  if (date === null) return // Shouldn't happen as "allowAllTime" is not enabled
  emit("update:modelValue", {
    date: DateFns.parse(date, "yyyy-MM-dd", new Date()),
  })
  hideDrawer()
}
</script>
